module.exports = __webpack_public_path__ + "static/media/dincondensed-bold-webfont.94087f14.woff";